module.exports = __webpack_public_path__ + "media/images/client/favicons/site-tile-310x310-551936afc6ef8174acc1e1c2f28a2214.png";